import React from 'react';
import {RowType} from "../../models/api/codegen/code";
// @ts-ignore
import {Html, Paragraph} from "uitabs-components";
import {Cards} from "./Cards";
import {ActionBoxes} from "./ActionBoxes";
import {Columns} from "./Columns";

export const Row: React.FC<{ row: RowType }> = ({row}) => {
    switch (row.type) {
        case "paragraph":
            return <Paragraph row={row}/>
        case "cards":
            return <Cards row={row}/>
        case "html":
            return <Html value={row.value}/>
        case "action_boxes":
            return <ActionBoxes {...row}/>
        case "columns":
            return <Columns row={row}/>
        default:
            return <></>
    }
}
